import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ConfigurationService } from '../../../Configuration/configuration.service';
import { Note5 } from '../notes/models/note5';
import { Notes2 } from './notes-model';

@Injectable({
  providedIn: 'root'
})
export class NoteService {

  constructor(private http: HttpClient,private configService: ConfigurationService) {
  }

  SaveNotes2(notes2: Notes2): Observable<any> {
    debugger
    const url = `${this.apiUrl}/Note1to10/SaveNotes2`;
    return this.http.post<any>(url, notes2);
  }

  saveNote5(note5Data: Note5): Observable<any> {
    debugger
    const url = `${this.apiUrl}/Note1to10/saveNote5`;
    return this.http.post<any>(url, note5Data);
  }

  SaveStatementofTrustees(form: any): Observable<any> { 
   // form.includeTAR = form.includeTAR==true?"true":'false'
 
    const url = `${this.apiUrl}/StatementofTrustees/SaveStatementofTrustees`;
    return this.http.post<any>(url, form);
  }
  GetStatementofTrustees(id: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/StatementofTrustees/GetStatementofTrustees?id=`;
    //const url = this.baseUrl + '/CharityDetails/GetStatementofTrustees?CentralUserId=';
    return this.http.get(url + id);
  }
  SaveIndependentExaminer(data: any): Observable<any> {
    debugger;
    const url = `${this.apiUrl}/IndependentExaminers/SaveIndependentExaminer`;
    return this.http.post<any>(url, [data]); 
;
  }

  GetIndependentExaminerDetails(id: number): Observable<any> {

    debugger
    const url = `${this.apiUrl}/IndependentExaminers/GetIndependentExaminerDetails?id=`;
    //const url = this.baseUrl + '/CharityDetails/GetStatementofTrustees?CentralUserId=';
    return this.http.get(url + id);

   // const url = `${this.apiUrl}/IndependentExaminers/GetIndependentExaminerDetails/${id}`;
  //  return this.http.get<any>(url);
  }



  private apiUrl = this.configService.getAPIBaseUrl();
}
